import { z } from 'zod';
import {
  EmployeeContractHistory,
  EmployeeGeneralInformation,
  EmployeeJobHistory,
  EmployeeOffBoarding,
  EmployeePermission,
  GoogleProductAndSKU,
  PerformanceReviewDetail,
  ProbationReviewDetail,
} from '../core';
import { EmployeeExternalAccount } from './employee-external-account';
import { EmployeePersonalInformation } from './employee-personal-information';

const EmployeeManager = z.object({
  id: z.string().default(''),
  name: z.string().default(''),
  // The manager has left (Employee Status Inactive on the Last Working Date).
  hasLeft: z.boolean().default(false),
});

export const EmployeeDetail = z.object({
  id: z.string().default(''),
  generalInformation: EmployeeGeneralInformation.default(EmployeeGeneralInformation.parse({})),
  personalInformation: EmployeePersonalInformation.default(EmployeePersonalInformation.parse({})),
  permission: EmployeePermission.default(EmployeePermission.parse({})),
  offBoarding: EmployeeOffBoarding.default(EmployeeOffBoarding.parse({})),
  jobHistories: z.array(EmployeeJobHistory).default([]),
  contractHistories: z.array(EmployeeContractHistory).default([]),
  contractNotes: z.string().nullable().default(''),
  jobHistoryNotes: z.string().nullable().default(''),
  externalAccounts: z.array(EmployeeExternalAccount).default([]),
  probationReview: ProbationReviewDetail.default(ProbationReviewDetail.parse({})),
  performanceReviews: z.array(PerformanceReviewDetail).default([]),
  managers: z.array(EmployeeManager).default([]),
  googleProductAndSKUForNew: GoogleProductAndSKU.nullable().default(null),
});

export type EmployeeDetailType = z.infer<typeof EmployeeDetail>;
export type EmployeeManagerType = z.infer<typeof EmployeeManager>;
